import * as Effects from "redux-saga/effects";
import { ProjectActions } from "../reducers/project/actionsNames";
import { IAttributes, Types } from "../reducers/project";

function* fetchContent(action) {
    const response = yield fetch(process.env.REACT_APP_API_URL + "/attribute", {
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
    });

    let attributes = yield response.json();

    attributes = attributes["attributes"]
        .map((a, i) => ({
            ...a,
            pimg: a.pimg || `/static/img/p${a.name}.png`,
            vimg:
                a.type === Types.Select
                    ? a.vimg || `/static/img/v${a.name}.png`
                    : undefined,
        }))
        .map((a) =>
            a.type === Types.Picker || a.type === Types.Input
                ? { ...a, value: a.default }
                : a
        )
        .filter((a) => !a.deleted);

    // yield Effects.put({
    //     type: ProjectActions.InsertAttributes,
    //     attributes: attributes,
    // });

    // if (!action?.ignoreDefault) {
    //     const selected = (attributes as IAttributes[]).filter((a) => a?.default);
    //
    //     yield Effects.put({
    //         type: ProjectActions.InsertSelectedAttributes,
    //         attributes: selected,
    //     });
    // }
}

export default function* () {
    yield Effects.takeLatest(ProjectActions.FetchAttributes, fetchContent);
}
